import i18n from 'i18next';
import { validate } from '../Passenger/utils';
import { TravellerFields } from '../TravellerForm/types';
import { DocTypes, TravellerFieldEnum } from '@websky/graphql';
import { validateDisabilities } from './components/components/Disabilities/utils';
import { PassengerType } from '../enums';
import { format, parseISO } from 'date-fns';
import { convertGenderToCorrectValue } from '../utils';
import memes from '../memes';
export const requiredFillData = (passengerFormValues, customerFormValues, passengerValues, accompanyingValues, ignoreFields = []) => {
    var _a;
    return (passengerValues
        .filter(field => !ignoreFields.find(ignoredField => (ignoredField === null || ignoredField === void 0 ? void 0 : ignoredField.name) !== (field === null || field === void 0 ? void 0 : field.name)))
        .some(field => {
        return !!validate(passengerFormValues[field.name], passengerFormValues, field.input, field.validations);
    }) ||
        ((_a = accompanyingValues === null || accompanyingValues === void 0 ? void 0 : accompanyingValues.filter(field => !ignoreFields.find(ignoredField => ignoredField.name !== field.name))) === null || _a === void 0 ? void 0 : _a.some(field => {
            return !!validate(customerFormValues[field.name], customerFormValues, field.input, field.validations);
        })) ||
        !!validateDisabilities(passengerFormValues));
};
export const getIsChildOrInfantPassenger = (passenger) => {
    if (!(passenger === null || passenger === void 0 ? void 0 : passenger.type)) {
        return false;
    }
    return [PassengerType.Child, PassengerType.Infant, PassengerType.InfantWithSeat].includes(passenger.type);
};
export const getPassengerDataLabel = (passengerValues, fieldsMap) => {
    var _a, _b, _c, _d, _e, _f;
    const labels = {};
    if (passengerValues.hasOwnProperty(TravellerFields.Gender)) {
        labels[TravellerFields.Gender] = i18n.t(convertGenderToCorrectValue(passengerValues[TravellerFields.Gender]), {
            ns: 'Passenger'
        });
    }
    labels[TravellerFields.BirthDate] = passengerValues[TravellerFields.BirthDate];
    if (passengerValues.hasOwnProperty(TravellerFields.Nationality)) {
        labels[TravellerFields.Nationality] = (_c = (_b = (_a = fieldsMap[TravellerFields.Nationality].validations) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.options.find(option => option.value === passengerValues[TravellerFields.Nationality])) === null || _c === void 0 ? void 0 : _c.label;
    }
    if (passengerValues.hasOwnProperty('docType')) {
        const docTypeValue = passengerValues['docType'];
        const docType = (_f = (_e = (_d = fieldsMap['docType'].validations
            .find(validation => validation.with === null ||
            validation.with.some(cond => passengerValues[cond.name] === cond.value))) === null || _d === void 0 ? void 0 : _d.options.find(option => option.value === docTypeValue)) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : docTypeValue;
        labels['docType'] = i18n.t(`Passenger:${docType}`);
        if (labels['docType'] && passengerValues.hasOwnProperty('docNumber')) {
            labels['docNumber'] = passengerValues['docNumber'];
        }
    }
    if (passengerValues.hasOwnProperty('docExpiryDate')) {
        labels['docExpiryDate'] = passengerValues['docExpiryDate'];
    }
    if (passengerValues.hasOwnProperty('loyaltyNumber')) {
        labels['loyaltyNumber'] = passengerValues['loyaltyNumber'];
    }
    return labels;
};
export const getProfileValues = (profile) => {
    const profileValuesMap = new Map();
    profile.values.forEach(value => {
        let actualValue = value.value;
        if (value.type === TravellerFieldEnum.Gender && value.value) {
            actualValue = value.value[0];
        }
        profileValuesMap.set(value.name, actualValue);
    });
    return profileValuesMap;
};
export const getMaxPrioritizedOption = memes((options) => {
    if (!options.length) {
        return null;
    }
    if (options.length === 1) {
        return options[0];
    }
    const maxOption = options.reduce((option, currentOption) => {
        var _a, _b;
        return ((_a = currentOption.priority) !== null && _a !== void 0 ? _a : 0) > ((_b = option.priority) !== null && _b !== void 0 ? _b : 0) ? currentOption : option;
    }, options[0]);
    if (maxOption.priority > 0) {
        return maxOption;
    }
    return null;
});
export const findFitDocument = (passenger, profile, targetNationality = 'RU', isInternationalFlight, actualDocumentType) => {
    var _a, _b;
    const availableDocument = profile.documents
        .map(doc => {
        let priority = 1;
        if (doc.citizenship === 'RU') {
            switch (doc.type) {
                case DocTypes.InternationalPassportRU:
                case DocTypes.DiplomaticPassport:
                    priority = isInternationalFlight ? 100 : 1;
                    break;
                case DocTypes.BirthRegDocument:
                    priority = isInternationalFlight
                        ? -1
                        : passenger.type === PassengerType.Child ||
                            passenger.type === PassengerType.Infant ||
                            passenger.type === PassengerType.InfantWithSeat
                            ? 100 // more priority that passport
                            : 1;
                    break;
                case DocTypes.Passport:
                    priority = isInternationalFlight ? -1 : 90;
                    break;
            }
        }
        return Object.assign(Object.assign({}, doc), { priority: doc.citizenship === targetNationality ? priority + 1000 : priority });
    })
        .filter(doc => doc.priority > 0)
        .sort((a, b) => b.priority - a.priority);
    if (actualDocumentType) {
        return (_a = availableDocument.find(doc => doc.type === actualDocumentType)) !== null && _a !== void 0 ? _a : null;
    }
    return (_b = availableDocument === null || availableDocument === void 0 ? void 0 : availableDocument[0]) !== null && _b !== void 0 ? _b : null;
};
export const getActualPassengerValues = (passengers, profile, id, document, isInternationalFlight, isFreezeOrder) => {
    var _a, _b, _c, _d, _e, _f;
    const profileValuesMap = getProfileValues(profile);
    const targetNationality = (_f = getMaxPrioritizedOption((_e = (_d = (_c = (_b = (_a = passengers[0]) === null || _a === void 0 ? void 0 : _a.values.find(value => value.name === 'nationality')) === null || _b === void 0 ? void 0 : _b.validationRules) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.options) !== null && _e !== void 0 ? _e : [])) === null || _f === void 0 ? void 0 : _f.value;
    const documentByType = findFitDocument(passengers[id], profile, targetNationality, isInternationalFlight, document);
    if (documentByType && !isFreezeOrder) {
        documentByType.values.forEach(doc => {
            var _a, _b;
            if (doc.value) {
                let actualValue = doc.value;
                if (doc.type === TravellerFieldEnum.DocExpiryDate) {
                    const isRequired = (_b = (_a = doc.validationRules) === null || _a === void 0 ? void 0 : _a.find(rule => { var _a, _b; return ((_b = (_a = rule.with) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.value) === documentByType.type; })) === null || _b === void 0 ? void 0 : _b.required;
                    if (isRequired) {
                        actualValue = format(parseISO(doc.value), 'dd.MM.yyyy');
                    }
                    else {
                        actualValue = '';
                    }
                }
                profileValuesMap.set(doc.name === 'citizenship' ? 'nationality' : doc.name, actualValue);
            }
            else {
                profileValuesMap.set(doc.name, '');
            }
        });
    }
    return profileValuesMap;
};
export const getEditableFields = (fields, passengerId, values, dirtyFields, isChangePassengers) => {
    var _a;
    if (isChangePassengers && ((_a = Object.keys(dirtyFields !== null && dirtyFields !== void 0 ? dirtyFields : {})) === null || _a === void 0 ? void 0 : _a.length)) {
        // to remove the readonly attribute from fields with a null value
        const nullableFields = fields
            .filter(field => { var _a, _b; return !field.defaultValue && !((_b = (_a = values.passengers) === null || _a === void 0 ? void 0 : _a[passengerId]) === null || _b === void 0 ? void 0 : _b[field.name]); })
            .map(field => `passengers[${passengerId}].${field.name}`);
        const includesNullableFields = Object.keys(dirtyFields).every(key => nullableFields.includes(key));
        if (!includesNullableFields) {
            return fields.map(field => {
                const fieldName = `passengers[${passengerId}].${field.name}`;
                const isNullableField = nullableFields.includes(fieldName);
                const isDirtyField = !isNullableField && (dirtyFields === null || dirtyFields === void 0 ? void 0 : dirtyFields[fieldName]);
                return Object.assign(Object.assign({}, field), { readonly: !isDirtyField });
            });
        }
    }
    return fields;
};
export function isNameFieldType(type, types = []) {
    const isFirstName = type === TravellerFieldEnum.FirstName || types.includes(TravellerFieldEnum.FirstName);
    const isLastName = type === TravellerFieldEnum.LastName || types.includes(TravellerFieldEnum.LastName);
    const isMiddleName = type === TravellerFieldEnum.MiddleName || types.includes(TravellerFieldEnum.MiddleName);
    return isFirstName || isLastName || isMiddleName;
}
export function isDateFieldType(type) {
    return type === TravellerFieldEnum.BirthDate || type === TravellerFieldEnum.DocExpiryDate;
}
export const getPassengersForFfpStatusCheck = (passengers, values) => {
    const mappedPassengers = [];
    passengers.forEach((passenger, index) => {
        if (values['passengers'][index]['loyaltyNumber']) {
            mappedPassengers.push({
                travellerId: String(index),
                values: passenger.values.map(field => ({
                    name: field.name,
                    type: field.type,
                    value: values['passengers'][index][field.name] || null
                }))
            });
        }
    });
    return mappedPassengers;
};
